export const getIsBetaPanel = () => {
  let data = sessionStorage.getItem("isBetaPanel");
  return data;
};

export const setIsBetaPanel = (status: boolean) => {
  sessionStorage.setItem("isBetaPanel", `${status}`);
};
